import { H6 } from "src/components/HeadingV2/HeadingV2.tsx";
import { Flex } from "src/components/Flex.tsx";
import * as styles from "./SetPriceListRow.style.tsx";
import { type PriceListResource, type VariantResource } from "@exonn/js-sdk";
import { formatPriceV2 } from "@exonn/utils";
import { useList } from "src/system/useList.tsx";
import { ResourceEnum } from "src/constants/constants.ts";
import { computeSetPrice } from "src/admin/modules/product/utils/computeSetPrice.tsx";
import { formatPriceListDateRange } from "src/components/Form/panels/PricePanel/utils/formatPriceListDateRange.ts";
import { useTranslation } from "react-i18next";
import { TranslationNamespaceEnum } from "src/lib/i18next/types.ts";

export function SetPriceListRow({
  id,
  variant,
}: {
  id: string;
  variant: VariantResource;
}) {
  const { t } = useTranslation(TranslationNamespaceEnum.PricePanel);

  const { data } = useList<PriceListResource>({
    resource: ResourceEnum.PriceList,
    include: ["currency"],
  });
  const priceLists = data?.data || [];

  const priceList = priceLists.find((priceList) => priceList.id === id)!;

  const setPrice = computeSetPrice({
    priceList,
    variant,
  });

  return (
    <div css={styles.itemStyle}>
      <div css={styles.triggerStyle}>
        <Flex
          alignItems={"center"}
          justifyContent={"space-between"}
          style={{ width: "100%" }}
        >
          <Flex flexDirection={"column"} alignItems={"flex-start"}>
            <H6>{priceList.title}</H6>
            <label css={styles.dateLabel}>
              {formatPriceListDateRange({ priceList, t })}
            </label>
          </Flex>
          <Flex alignItems={"center"}>
            <label css={styles.typeLabel}>
              {formatPriceV2(setPrice, priceList?.currency)}
            </label>
          </Flex>
        </Flex>
      </div>
    </div>
  );
}
